"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = exports.BackButton = exports.Footer = exports.SwitchMode = exports.StyledImage = exports.Trigger = exports.TriggerWrapper = exports.ButtonWrapper = exports.CaptionSmall = exports.Caption = exports.Headline = exports.Header = exports.Column = exports.tiers = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const router_1 = require("@reach/router");
const atoms_1 = require("@components/atoms");
const ArticleBody_1 = require("@components/atoms/ArticleBody");
const molecules_1 = require("@components/molecules");
const _utils_1 = require("@utils");
const _store_1 = __importDefault(require("@store"));
const _api_1 = __importDefault(require("@api"));
const _theme_1 = require("@theme");
exports.tiers = [{
        'name': 'digital',
        'features': ['Access to intelligence newsletters', 'Full access to daily content']
    }, {
        'name': 'community',
        'features': ['Everything in Digital', 'Individual Membership', 'Access to destination guides <em>(coming soon)</em>', 'Access to members-only local events <em>(coming soon)</em>', 'Access to member pricing <em>(coming soon)</em>'],
        'priceInCents': 24900
    }, {
        'name': 'bespoke',
        'features': ['Everything in Community', 'Household Membership', 'Bespoke travel mapping', 'Custom, all-inclusive travel planning', 'Dedicated on-the-ground support'],
        'priceInCents': 249900
    }]; // Component
var AccountInHeader = function AccountInHeader() {
    var _useGlobal = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), visibleDropdown = _useGlobal[0], setVisibleDropdown = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), panel = _useGlobal2[0], setPanel = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.setUser;
    }), user = _useGlobal3[0], setUser = _useGlobal3[1];
    var _useGlobal4 = _store_1.default(function (state) {
        return state.bookmarks;
    }, function (actions) {
        return actions.setBookmarks;
    }), setBookmarks = _useGlobal4[1];
    var _useHash = _utils_1.useHash(), hash = _useHash[0];
    var _useLocation = router_1.useLocation(), pathname = _useLocation.pathname;
    var protectedPaths = ['/account', '/profile', '/bookmarks', '/addresses', '/wallet', '/billing', '/account/', '/bookmarks/', '/addresses/', '/wallet/', '/billing/']; // TODO: these trailing slashes get added sometimes, dunno what that's about
    var navigate = router_1.useNavigate();
    react_1.default.useEffect(function () {
        if (visibleDropdown === undefined && panel && ['welcome', 'welcomeBack', 'upgraded', 'upgrade'].includes(panel)) {
            setPanel('home');
        }
    }, [visibleDropdown]);
    react_1.default.useEffect(function () {
        if (protectedPaths.includes(pathname)) {
            setVisibleDropdown(undefined);
        }
    }, [pathname]);
    react_1.default.useEffect(function () {
        if (!user) {
            _api_1.default('authenticate').then(function (r) {
                if (r.status !== 200) {
                    setPanel('login');
                    if (protectedPaths.includes(pathname)) {
                        navigate('/');
                    }
                    return;
                }
                r.json().then(function (user) {
                    setUser(user);
                    _api_1.default('listBookmarks').then(function (r) {
                        return r.json().then(function (bookmarks) {
                            return setBookmarks(bookmarks);
                        });
                    });
                    if (hash === '#welcome') {
                        if (user.membershipStatus === 'initialPayment' || user.membershipStatus === 'setupInterview') {
                            setPanel('payment');
                            setVisibleDropdown('account');
                            return;
                        }
                        else {
                            setPanel('welcome');
                            setVisibleDropdown('account');
                            return;
                        }
                    }
                    else if (hash === '#welcomeBack') {
                        setPanel('welcomeBack');
                        setVisibleDropdown('account');
                        return;
                    }
                    setPanel('home');
                });
            });
        }
    }, [user]);
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledMargin, null, !user && panel === 'login' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountLoginForm, null), !user && panel === 'pricing' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountPricing, null), !user && panel === 'register' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountRegisterForm, null), !user && panel === 'checkEmail' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountCheckEmail, null), user && panel === 'payment' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountPayment, null), user && panel === 'upgrade' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountUpgrade, null), user && panel === 'upgraded' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountUpgraded, null), user && panel === 'welcome' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountWelcome, null), user && panel === 'welcomeBack' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountWelcomeBack, null), user && panel === 'home' && /*#__PURE__*/ react_1.default.createElement(molecules_1.AccountHome, null)));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__Wrapper",
    componentId: "s4sxdx-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:center;background-color:", ";color:", ";padding:64px 0;", "{padding:80px 0;}", "{padding:96px 0;}", "{padding:128px 0;}"], _theme_1.palette.snow, _theme_1.palette.ink, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledMargin = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, props);
}).withConfig({
    displayName: "AccountInHeader__StyledMargin",
    componentId: "s4sxdx-1"
})(["display:flex;flex-direction:column;flex-wrap:wrap;width:100%;", "{flex-direction:row;align-content:flex-start;justify-content:space-between;}"], _utils_1.mediaQuery('tablet')); // Shared Components
/* Note: these supporting components are exported to child forms.
 *   (AccountLoginForm, AccountPricing, etc.)
 *
 * Changes to these components will percolate across the children.
 *
 * If you want to make a change to the shared components that is particular to
 *  a specific child form, go to the form and do this…
 *
 *    const styledColumn = styled(props => <Column {...props} />)` ...
 *
 * …or just remove the import and create a new supporting component within the child.
 */
// Column
exports.Column = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__Column",
    componentId: "s4sxdx-2"
})(["order:", ";position:relative;display:flex;flex-direction:column;justify-content:", ";align-items:stretch;width:100%;margin-bottom:", "px;", " &:first-of-type{margin-top:", "px;}&:last-of-type{margin-bottom:0;}", "{order:0 !important;width:", ";margin-bottom:0;}", "{width:", ";}"], function (props) {
    return !!props.orderReverse ? '1' : '0';
}, function (props) {
    return !!props.alignCenter ? 'center' : 'space-between';
}, function (props) {
    return !!props.orderReverse ? '0' : '64';
}, function (props) {
    return !!props.shortPadding ? 'margin-bottom: 32px;' : '';
}, function (props) {
    return !!props.orderReverse ? '32' : '0';
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.fullWidth ? '100%' : 'calc(50% - 20px)';
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !!props.fullWidth ? '100%' : 'calc(50% - 40px)';
}); // Header
exports.Header = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__Header",
    componentId: "s4sxdx-3"
})(["max-width:560px;padding-bottom:", "px;", "{", "}", "{padding-bottom:", "px;", "}", "{padding-bottom:", "px;", "}"], function (props) {
    return !!props.noPadding ? '0' : '24';
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.marginBottom ? 'margin-bottom: 40px;' : '';
}, _utils_1.mediaQuery('laptop'), function (props) {
    return !!props.noPadding ? '0' : '16';
}, function (props) {
    return !!props.marginBottom ? 'margin-bottom: 48px;' : '';
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !!props.noPadding ? '0' : '34';
}, function (props) {
    return !!props.marginBottom ? 'margin-bottom: 56px;' : '';
});
exports.Headline = styled_components_1.default.h2.withConfig({
    displayName: "AccountInHeader__Headline",
    componentId: "s4sxdx-4"
})(["", " color:", ";&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.1) * 1em);}&::after{margin-bottom:calc((1 - 1.4) * 1em);}"], _theme_1.type.h2, _theme_1.palette.black); // Copy
exports.Caption = styled_components_1.default.p.withConfig({
    displayName: "AccountInHeader__Caption",
    componentId: "s4sxdx-5"
})(["", " padding:", ";", " ", "{padding:", ";}", "{padding:", ";}", "{padding:", ";}"], _theme_1.type.p, function (props) {
    return !!props.paddingFull ? '16px 0 16px' : '16px 0 0';
}, ArticleBody_1.BodyCopyLink, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.paddingFull ? '24px 0 24px' : '24px 0 0';
}, _utils_1.mediaQuery('laptop'), function (props) {
    return !!props.paddingFull ? '32px 0 32px' : '32px 0 0';
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !!props.paddingFull ? '40px 0 40px' : '40px 0 0';
});
exports.CaptionSmall = styled_components_1.default.p.withConfig({
    displayName: "AccountInHeader__CaptionSmall",
    componentId: "s4sxdx-6"
})(["", " padding:", ";", " ", "{padding:", ";}"], _theme_1.type.pSmall, function (props) {
    return !!props.paddingFull ? '16px 0' : '16px 0 0';
}, ArticleBody_1.BodyCopyLink, _utils_1.mediaQuery('laptop'), function (props) {
    return !!props.paddingFull ? '24px 0' : '24px 0 0';
}); // Button
exports.ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__ButtonWrapper",
    componentId: "s4sxdx-7"
})(["padding-top:8px;padding-top:", "px;", "{padding-top:", "px;}", "{padding-top:", "px;}", "{padding-top:", "px;}"], function (props) {
    return !!props.shortPadding ? '8' : '32';
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.shortPadding ? '8' : '32';
}, _utils_1.mediaQuery('laptop'), function (props) {
    return !!props.shortPadding ? '8' : '48';
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !!props.shortPadding ? '16' : '64';
}); // Trigger
exports.TriggerWrapper = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__TriggerWrapper",
    componentId: "s4sxdx-8"
})(["padding:", ";", "{padding:", ";}", "{padding:", ";}", "{padding:", ";}"], function (props) {
    return !!props.paddingTop ? '32px 0 0' : '0 0 32px';
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.paddingTop ? '40px 0 0' : '0 0 40px';
}, _utils_1.mediaQuery('laptop'), function (props) {
    return !!props.paddingTop ? '48px 0 0' : '0 0 48px';
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !!props.paddingTop ? '56px 0 0' : '0 0 56px';
});
exports.Trigger = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__Trigger",
    componentId: "s4sxdx-9"
})(["position:relative;width:fit-content;padding-bottom:6px;margin:", ";", " color:", ";cursor:pointer;white-space:nowrap;&::after{z-index:2;position:absolute;bottom:0;left:0;background-color:", ";width:100%;height:1px;content:'';}", "{filter:contrast(100%);transition:filter 0.25s ease-in-out;&::after{transform:translate3d(0,0,0);transition:transform 0.25s ease-in-out;}&:hover{filter:contrast(140%);&::after{transform:translate3d(0,-6px,0);}}}", "{padding-bottom:8px;}", "{padding-bottom:12px;}"], function (props) {
    return !!props.alignLeft ? '0' : '0 auto';
}, _theme_1.type.label, _theme_1.palette.brown, _theme_1.palette.brown, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Image
exports.StyledImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, props);
}).withConfig({
    displayName: "AccountInHeader__StyledImage",
    componentId: "s4sxdx-10"
})(["max-height:200px;", "{max-height:320px;}", "{max-height:380px;}", "{max-height:420px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.SwitchMode = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__SwitchMode",
    componentId: "s4sxdx-11"
})(["position:relative;", " margin-top:2em;color:", ";cursor:pointer;"], _theme_1.type.label, _theme_1.palette.brown); // Footer
exports.Footer = styled_components_1.default.ul.withConfig({
    displayName: "AccountInHeader__Footer",
    componentId: "s4sxdx-12"
})(["display:flex;justify-content:center;width:100%;padding-top:40px;& > li{margin-right:16px;}& > li:last-of-type{margin-right:0 !important;}", "{padding-top:48px;& > li{margin-right:24px;}}", "{padding-top:64px;& > li{margin-right:32px;}}", "{padding-top:80px;& > li{margin-right:40px;}}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.BackButton = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__BackButton",
    componentId: "s4sxdx-13"
})(["position:absolute;z-index:2;top:12px;left:14px;display:flex;justify-content:center;align-items:center;background-color:", ";width:40px;height:40px;padding-left:2px;border:1px solid ", ";border-radius:50%;cursor:pointer;transition:background-color 0.2s ease-in-out,border-color     0.2s ease-in-out;&::after{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:50%;box-shadow:0px 12px 18px ", ";content:'';opacity:0.2;transition:opacity 0.25s ease-in-out;pointer-events:none;}", "{top:20px;left:20px;&:hover{background-color:", ";border:1px solid ", ";&::after{opacity:1;}}}", "{left:24px;top:40px;width:56px;height:56px;}", "{left:28px;width:64px;height:64px;}"], _theme_1.palette.white, _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.rgba(_theme_1.palette.black, 0.16), _utils_1.mediaQuery('tablet'), _theme_1.palette.ink, _utils_1.rgba(_theme_1.palette.ink, 1), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.Arrow = styled_components_1.default.div.withConfig({
    displayName: "AccountInHeader__Arrow",
    componentId: "s4sxdx-14"
})(["position:relative;display:inline-block;width:8px;height:8px;transform:rotate(135deg);&::after{position:absolute;top:0;left:0;display:inline-block;width:100%;height:100%;border-bottom-style:solid;border-bottom-width:2px;border-right-style:solid;border-right-width:2px;border-color:", ";transition:border-color 0.2s ease-in-out;content:'';}", "{", ":hover &::after{border-color:", ";}}", "{width:10px;height:10px;}"], _theme_1.palette.ink, _utils_1.mediaQuery('tablet'), exports.BackButton, _theme_1.palette.snow, _utils_1.mediaQuery('laptop')); // Typing
exports.default = AccountInHeader;
